import {makeStyles} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";

export default makeStyles(({spacing, palette}) => ({
  root: {
    padding: spacing(3),
    // Vertical margin gives the chromeless preview some breathing room; the
    // paper grows with its content and the page provides the single scroll.
    // No `maxHeight` / `overflow` here on purpose — capping the height forced
    // a nested scroll inside the paper while the window still had free space.
    margin: spacing(3, "auto"),
    // Wider preview so grids with many columns fit with less horizontal
    // scroll; capped at 95vw so it never overflows a narrow window.
    maxWidth: "min(1600px, 95vw)",
    background: palette.leftMenuBackground.main,
    color: palette.contrastText.main,
    borderColor: palette.separator.main,
  },
  grid: {
    padding: 0,
    marginBottom: spacing(1),
    background: palette.leftMenuBackground.main,
  },
  tableName: {
    color: palette.tableDataRow.main,
    lineHeight: "19px",
    fontSize: "14px",
    letterSpacing: "0.15px",
    marginBottom: spacing(1),
  },
  responseGrid: {
    color: grey[600],
    fontSize: "12px",
    lineHeight: "120%",
    letterSpacing: "1.2px",
    textTransform: "uppercase",
    margin: spacing(2, 0),
  },
  title: {
    fontSize: "28px",
  },
  // Loading / not-found states: centered in the viewport so the chromeless
  // window shows a clear status instead of a blank page.
  statusRoot: {
    minHeight: "60vh",
    width: "100%",
    textAlign: "center",
    padding: spacing(3),
  },
  statusTitle: {
    fontSize: "20px",
    fontWeight: 500,
    color: palette.contrastText.main,
  },
  statusSubtitle: {
    fontSize: "14px",
    color: grey[600],
  },
}));
